export default __webpack_public_path__ + "icon-madfit.91bca23d.png";